import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const clockStrokeTestId = 'clock-stroke-test-id';

export const ClockStrokeIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const iconSize = IconSizes[size];
    const fillStyle = cn(Styles[fill], Styles.fill);

    return (
        <svg
            width={iconSize}
            height={iconSize}
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox={`1 1 23 23`}
            data-testid={clockStrokeTestId}
        >
            <path
                className={fillStyle}
                d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 2a1 1 0 0 1 1 1v5.382l3.447 1.724a1 1 0 0 1 .494 1.234l-.047.107a1 1 0 0 1-1.341.447l-4-2A1 1 0 0 1 11 12V6a1 1 0 0 1 1-1z"
                id="a"
            />
        </svg>
    );
};

ClockStrokeIcon.TEST_ID = clockStrokeTestId;
